// Generated by Melange

import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarNestedItem from "./SidebarNestedItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SidebarDocuments(Props) {
  let org = Props.org;
  let currentRoute = Props.currentRoute;
  let setBar = Props.setBar;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  let tmp;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    tmp = false;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$1 = currentRoute._1;
        if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string" || match$1.TAG !== /* Documents */ 1) {
          tmp = false;
        } else {
          let tmp$1 = match$1._0;
          tmp = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* Batches */ 6 ? false : true;
        }
        break;
      case /* Admin */ 7 :
        const match$2 = currentRoute._0;
        if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string" || match$2.TAG !== /* Orgs */ 1) {
          tmp = false;
        } else {
          const match$3 = match$2._0;
          if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string") {
            tmp = false;
          } else {
            const match$4 = match$3._1;
            if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string" || match$4.TAG !== /* Documents */ 1) {
              tmp = false;
            } else {
              let tmp$2 = match$4._0;
              tmp = /* tag */ typeof tmp$2 === "number" || typeof tmp$2 === "string" || tmp$2.TAG !== /* Batches */ 6 ? false : true;
            }
          }
        }
        break;
      default:
        tmp = false;
    }
  }
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("button", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-5 h-5",
            src: StaticAsset.src("/static/icons/back-arrow.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            className: "ml-4 text-white",
            children: "Документы"
          })
        ],
        className: "px-6 mt-8 mb-6 flex items-center",
        onClick: (function (param) {
          Curry._1(setBar, (function (param) {
            return "main";
          }));
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
        isActive: tmp,
        route: contextRoute({
          TAG: /* Documents */ 1,
          _0: {
            TAG: /* Batches */ 6,
            _0: /* List */ 0
          }
        }),
        activeIcon: JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/docs-white-20.svg")
        }),
        icon: JsxRuntime.jsx("img", {
          className: "w-5 h-5",
          src: StaticAsset.src("/static/icons/docs.svg")
        }),
        title: "Реестры"
      })
    ]
  });
}

const make = SidebarDocuments;

export {
  make,
}
/* Buhta_cabinet__Route Not a pure module */
